import React from 'react';
import { createRoot } from 'react-dom/client';
import Routes from './routes';

import 'normalize.css';
import 'tdesign-react/es/style/index.css';
import '@/common/css/base.less';

const Root = () => (
  <Routes />
);

const container = document.getElementById('flexible-code-ifbook-home-root');
const root = createRoot(container);
root.render(<Root />);
